import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  createFilterOptions,
  Divider,
  Grid2,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import {
  CellTower,
  Clear,
  Password,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";

import { axiosPrivate } from "../../axios/axios";
import { api, companyInfo, roleInfo, userTypeInfo } from "../API/config";
import { commonCss } from "../../StyleConfig/CommonCss";
import NormalTable from "../../Component/NormalTable";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import moment from "moment";
import dayjs from "dayjs";
// import utc from "dayjs/plugin/utc";
// import timezone from "dayjs/plugin/timezone";
import { useDispatch, useSelector } from "react-redux";
import ErrorProps from "../../Component/Errorprops";
import { toast } from "react-toastify";
// import { convertToRaw, EditorState,ContentState   } from "draft-js";
// import { Editor } from "react-draft-wysiwyg";
// import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
// import 'draft-js/dist/Draft.css';
// import draftToHtml from "draftjs-to-html";
// import htmlToDraft from 'html-to-draftjs';

// dayjs.extend(utc);
// dayjs.extend(timezone);

const EmailTemplateModal = ({ mode, handleCloseClick, editData }) => {
  const login = useSelector((state) => state.auth.loginInfo);
  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [editStore,setEditorState]=useState()
  const [error,setError]=useState({})


  const OPTIONS_LIMIT = 10;
  const defaultFilterOptions = createFilterOptions();

  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state);
  };
  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };


  // useEffect(() => {
  //   getData();
  // }, []);

  // const getData = async () => {
  //   setLoading(true);
  //   const getUserType = api.userType.getAll;
  //   await axiosPrivate
  //     .get(`${getUserType}`)
  //     .then((res) => {
  //       setuserType(res.data.data);
  //       setLoading(false);
  //     })
  //     .catch((e) => {
  //       console.log(e);
  //       setuserType([]);
  //       setLoading(false);
  //     });

  //   const getCompany = api.company.getAll;
  //   await axiosPrivate
  //     .get(`${getCompany}`)
  //     .then((res) => {
  //       setCompany(res.data.data);
  //       setLoading(false);
  //     })
  //     .catch((e) => {
  //       console.log(e);
  //       setCompany([]);
  //       setLoading(false);
  //     });
  //   const terminalLink = api.terminal.getAll;
  //   await axiosPrivate
  //     .get(`${terminalLink}`)
  //     .then((res) => {
  //       setTerminal(res.data.data);
  //     })
  //     .catch((e) => {
  //       console.log(e);
  //       setTerminal([]);
  //     });

  //   if (mode === "Edit") {
  //     getRoleByUserType(editData.userTypeId);
  //   }
  // };

  const handleClickShowPassword = () => setShowPassword(!showPassword);

//   const getData = () => {
//     if(editData.mailBody!==null&&mode === "Edit"){
//     const contentBlock = htmlToDraft(editData.mailBody);
//     if (contentBlock) {
//         const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
//         setEditorState(EditorState.createWithContent(contentState));
//     }
//   }else{
//     setEditorState(EditorState.createEmpty());
//   }
    
// };

  const initialValue = {
    templateName: mode === "Edit" ? editData.templateName : "",
    templateKey: mode === "Edit" ? editData.templateKey : "",
    fromName: mode === "Edit" ? editData.fromName : "",
    fromEmailId: mode === "Edit" ? editData.fromEmailId : "",
    
    subject:
      mode === "Edit"
        ? editData.subject
        : '',
        ccEmail:
      mode === "Edit"
        ? editData.ccEmail 
        : '',
        bccEmail: mode === "Edit" ? editData.bccEmail : '',
      mailBody: mode === "Edit" ? editData.mailBody:""
  };

  const onSubmit = async (value) => {
    console.log(value);
    setLoading(true);
    const createLink = api.emailTemplate.add;
    const updateLink = api.emailTemplate.edit;
    const postDataValidate = {
      ...value,
      // mailBody: draftToHtml(convertToRaw(editStore.getCurrentContent())),
    };
 validationSchema
      .validate(postDataValidate, { abortEarly: false })
      .then((responseData) => {
        setError({});
        if (mode === "Create") {
          const postData = {
            ...value,
            // mailBody: draftToHtml(convertToRaw(editStore.getCurrentContent())),
          };
          console.log(postData)
           axiosPrivate
            .post(`${createLink}`, postData)
            .then((res) => {
              console.log(res.data);
              setLoading(false);
              handleCloseClick();
            })
            .catch((e) => {
              setLoading(false);
              toast.error(e.response.data.message);
              console.log(e, "create email template");
            });
        } else {
          const updateAC = {
            id: editData.id, 
            ...value,
            // mailBody: draftToHtml(convertToRaw(editStore.getCurrentContent())),
          };
          console.log(updateAC);
           axiosPrivate
            .put(`${updateLink}/${editData.id}`, updateAC)
            .then((res) => {
              console.log(res);
              setLoading(false);
              handleCloseClick();
            })
            .catch((e) => {
              setLoading(false);
              toast.error(e.response.data.message);
              console.log(e, "update email template");
            });
        }
      })
      .catch((err) => {
        console.log(err)
        const errors = err.inner.reduce((acc, error) => {
          return {
            ...acc,
            [error.path]: error.errors[0],
          };
        }, {});
        setError(errors);
        setLoading(false);
        toast.error("Please Fill Required Fields");
      });
  
   
  };

  const handleCancel = () => {
    handleCloseClick();
  };

 


  const validationSchema = Yup.object().shape({
    templateName: Yup.string().required("This field is required"),
    templateKey: Yup.string().required("This field is required"),
    fromName: Yup.string().required("This field is required"),
    fromEmailId: Yup.string().email().required("This field is required"),
    mailBody: Yup.string().required("This field is required"),
    

    // roleIds: Yup.array().min(1, "This field is required"),
  });
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: commonCss.titleColor,
            fontSize: commonCss.titleFontSize,
            fontWeight: commonCss.titleFontWeight,
          }}
        >
          {api.emailTemplate.title}
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Formik
        initialValues={initialValue}
        onSubmit={onSubmit}
        // validationSchema={validationSchema}
      >
        {({ handleChange, setFieldValue, values, resetForm, errors }) => (
          <Form>
            <Grid2 container spacing={"1rem"}>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <InputLabel>
                  <Typography
                    variant="body2"
                    fontWeight={commonCss.labelFontWeight}
                    color={commonCss.labelInputColor}
                  >
                    Template Name
                    <Typography
                      component="span"
                      color="error"
                      fontWeight="bold"
                      sx={{ ml: 0.5 }}
                    >
                      *
                    </Typography>
                  </Typography>
                </InputLabel>
                <TextField
                  size={"small"}
                  type="text"
                  name="templateName"
                  value={values.templateName}
                  fullWidth
                  onChange={handleChange}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: commonCss.inputBackgroundColor,
                      borderRadius: commonCss.inputBorderRadius,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: commonCss.inputBorderColor,
                    },
                  }}
                />
                {error.templateName !== undefined ? (
                                        <ErrorProps>{error.templateName}</ErrorProps>
                                      ) : null}
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <InputLabel>
                  <Typography
                    variant="body2"
                    fontWeight={commonCss.labelFontWeight}
                    color={commonCss.labelInputColor}
                  >
                    Template Key
                    <Typography
                      component="span"
                      color="error"
                      fontWeight="bold"
                      sx={{ ml: 0.5 }}
                    >
                      *
                    </Typography>
                  </Typography>
                </InputLabel>
                <TextField
                  size={"small"}
                  type="text"
                  name="templateKey"
                  value={values.templateKey}
                  fullWidth
                  onChange={handleChange}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: commonCss.inputBackgroundColor,
                      borderRadius: commonCss.inputBorderRadius,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: commonCss.inputBorderColor,
                    },
                  }}
                />
                {error.templateKey !== undefined ? (
                                        <ErrorProps>{error.templateKey}</ErrorProps>
                                      ) : null}
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <InputLabel>
                  <Typography
                    variant="body2"
                    fontWeight={commonCss.labelFontWeight}
                    color={commonCss.labelInputColor}
                  >
                    From Name
                    <Typography
                      component="span"
                      color="error"
                      fontWeight="bold"
                      sx={{ ml: 0.5 }}
                    >
                      *
                    </Typography>
                  </Typography>
                </InputLabel>
                <TextField
                  size={"small"}
                  type="text"
                  name="fromName"
                  value={values.fromName}
                  fullWidth
                  onChange={handleChange}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: commonCss.inputBackgroundColor,
                      borderRadius: commonCss.inputBorderRadius,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: commonCss.inputBorderColor,
                    },
                  }}
                />
                {error.fromName !== undefined ? (
                                        <ErrorProps>{error.fromName}</ErrorProps>
                                      ) : null}
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <InputLabel>
                  <Typography
                    variant="body2"
                    fontWeight={commonCss.labelFontWeight}
                    color={commonCss.labelInputColor}
                  >
                    From Email
                    <Typography
                      component="span"
                      color="error"
                      fontWeight="bold"
                      sx={{ ml: 0.5 }}
                    >
                      *
                    </Typography>
                  </Typography>
                </InputLabel>
                <TextField
                  size={"small"}
                  type="email"
                  name="fromEmailId"
                  value={values.fromEmailId}
                  // slotProps={{
                  //   input: {
                  //   readOnly: mode === "Edit",
                   
                  //   },
                  // }}
                  fullWidth
                  onChange={handleChange}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor:commonCss.inputBackgroundColor,
                      borderRadius: commonCss.inputBorderRadius,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: commonCss.inputBorderColor,
                    },
                  }}
                />
                {error.fromEmailId !== undefined ? (
                                        <ErrorProps>{error.fromEmailId}</ErrorProps>
                                      ) : null}
              </Grid2>
              <Grid2 size={{ xs: 12 }}>
                <InputLabel>
                  <Typography
                    variant="body2"
                    fontWeight={commonCss.labelFontWeight}
                    color={commonCss.labelInputColor}
                  >
                    Subject
                    {/* <Typography
                      component="span"
                      color="error"
                      fontWeight="bold"
                      sx={{ ml: 0.5 }}
                    >
                      *
                    </Typography> */}
                  </Typography>
                </InputLabel>
                <TextField
                  size={"small"}
                  type="text"
                  name="subject"
                  value={values.subject}
                  fullWidth
                  onChange={handleChange}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: commonCss.inputBackgroundColor,
                      borderRadius: commonCss.inputBorderRadius,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: commonCss.inputBorderColor,
                    },
                  }}
                />
                {/* {errors.templateName && (
                  <ErrorMessage name="templateName">
                    {(error) => <ErrorProps>{error}</ErrorProps>}
                  </ErrorMessage>
                )} */}
              </Grid2>
              <Grid2 size={{ xs: 12}}>
                <InputLabel>
                  <Typography
                    variant="body2"
                    fontWeight={commonCss.labelFontWeight}
                    color={commonCss.labelInputColor}
                  >
                    Mail Body
                    <Typography
                      component="span"
                      color="error"
                      fontWeight="bold"
                      sx={{ ml: 0.5 }}
                    >
                      *
                    </Typography>
                  </Typography>
                </InputLabel>
                {/* <Box sx={{background:"white"}}> */}
                  
                {/* <Editor
        editorState={editStore}
          wrapperClassName="wrapper-class"
        editorClassName="editor-class"
        // toolbarClassName="toolbar-class"
        onEditorStateChange={(e)=>{
          setEditorState(e)
        }}
        /> */}
        <TextField
                  size={"small"}
                  type="text"
                  name="mailBody"
                  value={values.mailBody}
                  fullWidth
                  multiline
                  minRows={6}
                  onChange={handleChange}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: commonCss.inputBackgroundColor,
                      borderRadius: commonCss.inputBorderRadius,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: commonCss.inputBorderColor,
                    },
                  }}
                />
                {/* <CodeMirror
                value={values.mailBody}
                options={{
                    mode: 'xml',
                    theme: 'default',
                    lineNumbers: true,
                }}
                onBeforeChange={(editor, data, value) => {
                    setFieldValue("mailBody",value)
                }}
            /> */}
        {/* </Box> */}
               
                {error.mailBody !== undefined ? (
                                        <ErrorProps>{error.mailBody}</ErrorProps>
                                      ) : null}
              </Grid2>




              <Grid2 size={{ xs: 12, md: 6 }}>
                <InputLabel>
                  <Typography
                    variant="body2"
                    fontWeight={commonCss.labelFontWeight}
                    color={commonCss.labelInputColor}
                  >
                    CC Email
                    {/* <Typography
                      component="span"
                      color="error"
                      fontWeight="bold"
                      sx={{ ml: 0.5 }}
                    >
                      *
                    </Typography> */}
                  </Typography>
                </InputLabel>
                <TextField
                  size={"small"}
                  type="email"
                  name="ccEmail"
                  value={values.ccEmail}
                  // slotProps={{
                  //   input: {
                  //   readOnly: mode === "Edit",
                   
                  //   },
                  // }}
                  fullWidth
                  onChange={handleChange}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor:commonCss.inputBackgroundColor,
                      borderRadius: commonCss.inputBorderRadius,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: commonCss.inputBorderColor,
                    },
                  }}
                />
                {/* {errors.fromEmailId && (
                  <ErrorMessage name="fromEmailId">
                    {(error) => <ErrorProps>{error}</ErrorProps>}
                  </ErrorMessage>
                )} */}
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <InputLabel>
                  <Typography
                    variant="body2"
                    fontWeight={commonCss.labelFontWeight}
                    color={commonCss.labelInputColor}
                  >
                    Bcc Email
                    {/* <Typography
                      component="span"
                      color="error"
                      fontWeight="bold"
                      sx={{ ml: 0.5 }}
                    >
                      *
                    </Typography> */}
                  </Typography>
                </InputLabel>
                <TextField
                  size={"small"}
                  type="text"
                  name="bccEmail"
                  value={values.bccEmail}
                  // slotProps={{
                  //   input: {
                  //   readOnly: mode === "Edit",
                   
                  //   },
                  // }}
                  fullWidth
                  onChange={handleChange}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor:commonCss.inputBackgroundColor,
                      borderRadius: commonCss.inputBorderRadius,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: commonCss.inputBorderColor,
                    },
                  }}
                />
                {/* {errors.fromEmailId && (
                  <ErrorMessage name="fromEmailId">
                    {(error) => <ErrorProps>{error}</ErrorProps>}
                  </ErrorMessage>
                )} */}
              </Grid2>
              
            
              <Grid2 container size={12} justifyContent={"flex-end"} gap="1rem">
                <Button
                  onClick={handleCancel}
                  variant="contained"
                  sx={{
                    backgroundColor: commonCss.green,
                    borderRadius: commonCss.buttonBorderRadius,
                    textTransform: "none",
                    padding: "0.6rem 1rem",
                    color: commonCss.buttonTextColor,
                    width: "10vw",
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type={"submit"}
                  variant="contained"
                  disabled={loading}
                  sx={{
                    backgroundColor: commonCss.green,
                    borderRadius: commonCss.buttonBorderRadius,
                    textTransform: "none",
                    padding: "0.6rem 1rem",
                    color: commonCss.buttonTextColor,
                    width: "10vw",
                  }}
                >
                  Submit
                </Button>
              </Grid2>
            </Grid2>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default EmailTemplateModal;
